module.exports = __webpack_public_path__ + "static/media/hospital-symbol.5dfb5451.svg";